<template>
  <nav class="tabs">
    <router-link
      v-for="category in categories"
      active-class="tab--active"
      :class="classForCategory(category)"
      :key="category.id"
      :to="urlForCategory(category)"
      @click.native="changeCategory()"
    >
      <strong>{{ category.name }}</strong>
      <span>
        <i class="fa fa-check" v-if="hasSelectedSuggestion(category)"></i>
      </span>

      <p v-if="hasSelectedNominee(category)">
        {{ getSelectedNominee(category).name }}
      </p>

      <p v-else-if="hasSelectedSuggestion(category)">
        {{ getSelectedSuggestion(category).suggestionName }}
      </p>
    </router-link>
  </nav>
</template>

<script>
export default {
  name: 'Tabs',

  props: {
    selectedId: Number,
  },

  methods: {
    classForCategory(category) {
      return {
        tab: true,
        'tab--selected': this.hasSelectedSuggestion(category),
      }
    },
    changeCategory() {
      this.$emit('changeCategory')
    },

    urlForCategory(category) {
      return {
        name: 'category',
        params: {
          categorySlug: category.slug,
        },
      }
    },

    getSelectedNominee(category) {
      const selected = this.selected.find(({ categoryId }) => categoryId === category.id)

      if (!selected) {
        return null
      }

      const nominees = this.$store.getters.getNomineesByCategoryId(category.id)

      return nominees.find((nominee) => nominee.id === selected.nomineeId)
    },

    getSelectedSuggestion(category) {
      const selected = this.selected.find(({ categoryId }) => categoryId === category.id)

      if (!selected) {
        return null
      }

      const suggestions = this.$store.state.suggestions
      return suggestions.find((suggestion) => suggestion.categoryId === selected.categoryId)
    },

    hasSelectedSuggestion(category) {
      return this.selected.find(({ categoryId }) => categoryId === category.id) != null
    },

    hasSelectedNominee(category) {
      return this.getSelectedNominee(category) != null
    },
  },

  computed: {
    categories() {
      return this.$store.state.categories
    },

    selected() {
      return this.$store.state.selected
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Tabs.vue